import BaiduLoader from 'baidu-map-loader';
import Mustache from 'mustache';
import MarkerClusterer from 'bmaplib.markerclusterer';

const appKey = 'WUNfiXYQoKBE5eHM4qvNgkVVjHKAzesk';
BaiduLoader.ak = appKey
BaiduLoader.VERSION = '3.0'

const cardTemplate = document.querySelector('.js-map-card-template')?.innerHTML;

let appBaidu = null;
let appMap = null;
let appPoints = [];
let appMarkers = [];
let clusterer = null;

export default class Baidu {
  constructor() {}

  /**
   * Init map (also call this to update map with new coordinates)
   * @param {element} mapEl element to render map to
   * @param {array} items from API
   */
  async init(mapEl, items) {
    this.mapEl = mapEl;
    this.items = items;
    appPoints = [];
    appMarkers = [];

    if (this.mapEl && this.items) {
      if (!appBaidu && !appMap) {
        await this.load();
      } else {
        if (clusterer) {
          // Remove old markers
          clusterer.removeMarkers(appMarkers);
        }
        this.render();
      }
      window.baidu = this;
    }
  }

  /**
   * Load map
   */
  async load() {
    BaiduLoader.apiLoad()
    BaiduLoader.onLoad((Baidu) => {
      appBaidu = Baidu;
      this.render();
    })
  }

  /**
   * Render map
   */
  async render() {
    appMap = new appBaidu.Map(this.mapEl);
    appMap.addControl(new appBaidu.NavigationControl());
    appMap.addControl(new appBaidu.ScaleControl());
    appMap.addControl(new appBaidu.OverviewMapControl());
    appMap.addControl(new appBaidu.MapTypeControl());
    appMap.setMapStyle({style: 'grayscale'});
    appMap.centerAndZoom(new appBaidu.Point(116.409, 39.918), 4)

    // No need to get coordinates etc if no items provided
    if (!this.items.length) {
      return;
    }

    const pointArr = [];

    for (const location of this.items) {
      const point = location?.coords?.lng && location?.coords?.lat ? new appBaidu.Point(location.coords.lng, location.coords.lat) : null;
      if (point) {
        pointArr.push(point);
      }
    }

    if (pointArr.length) {
      await this.getCoordinates(pointArr);
    }
  }

  /**
   * Get baidu point coordinates
   * @param {array} pointArr array from API data
   */
  async getCoordinates(pointArr) {
    const chunkSize = 10, chunks = [];

    for (let i = 0; i < pointArr.length; i += chunkSize) {
      chunks.push(pointArr.slice(i, i + chunkSize));
    }

    for (const chunk of chunks) {
      await this.resolvePoints(chunk);
    }
    this.populateMap();
  }

  /**
   * Populate the map with markers
   */
  populateMap() {
    for (let i = 0; i < appPoints.length; i++) {
      const point = appPoints[i];
      this.createMarker(point, this.items[i]);
    }
  }

  /**
   * Translate coordinates to baidu points
   * @param {array} points - baidu points
   * @returns {Promise} Returns promise value to be able to use Promise.all with baidu's callbacks.
   */
  resolvePoints(points) {
    return new Promise((resolve) => {

      let convertor = new appBaidu.Convertor();
      convertor.translate(points, 1, 5, (response) => {
        const { status, points } = response;

        if (status === 0 && points.length) {
          appPoints.push(...points);
        }

        resolve(true);
      });
    })
  }

  /**
   * Create marker
   * @param {object} point baidu point (coordinates)
   * @param {object} location location data from API
   */
  createMarker(point, location) {
    location.logo = location.clientLogo;
    let marker = new appBaidu.Marker(point, {
      title: location.title,
      shadow: null
    });
    marker.addEventListener('click', () => {
      let infoWindow = new appBaidu.InfoWindow(Mustache.render(cardTemplate, location), {
        width: 350,
        offset: new appBaidu.Size(175, 200)
      });
      appMap.openInfoWindow(infoWindow, marker.getPosition());
    })
    appMarkers.push(marker);

    if (appMarkers.length === this.items.length) {
      let mcStyle = {
        url: '',
        className: 'baidu-marker',
        size: new appBaidu.Size(64, 64),
        anchor: [10, 0],
        textSize: 16,
        textColor: '#ffffff; background-color: #007cb0; border-radius: 9999px;'
      };

      let mcOptions = {
        markers: appMarkers,
        maxZoom: 15,
        gridSize: 50,
        styles: [mcStyle, mcStyle, mcStyle]
      };

      clusterer = new MarkerClusterer(appMap, mcOptions);

      if (this.items.length === 1) {
        appMap.panTo(point);
      } else {
        // appMap.setViewport(appPoints)
        appMap.centerAndZoom(new appBaidu.Point(113.844656, 22.632231), 1)
      }
    }
  }
}
